import types from '../types';

import { getCheckboxGroupNextState } from '.';

/**
 * @typedef  Params
 * @type {Object}
 * @property {types.Filter[]} filters
 * @property {string} id
 * @property {string} filterId
 */

/**
 * @param {Params}
 * @returns {types.Filter[]}
 */
const setFiltersCheckboxGroupState = ({ filters, id, filterId }) => {
    if (!filters || !Array.isArray(filters) || !filters.length) {
        return [];
    }

    return filters.map(filter => {
        if (filter.id === filterId && filter.type === 'checkbox') {
            const options = getCheckboxGroupNextState(filter.options, id);

            return {
                ...filter,
                options
            };
        }

        return filter;
    });
};

export default setFiltersCheckboxGroupState;
